import { useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext.js";
import { rutaInicioPorRol } from "../../auth/roles.js";
import { AdultScreen, Content } from "../../components/Layout.js";
import { Card } from "../../components/Card.js";
import { Button } from "../../components/Button.js";
import { Field, TextInput, ErrorBanner } from "../../components/Form.js";
import { Mascot } from "../../components/Mascot.js";
import { AppVersion } from "../../components/AppVersion.js";
import { useT } from "../../i18n/index.js";
import { mensajeDeError } from "../../hooks/useQuery.js";

export function LoginPage() {
  const t = useT();
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function onSubmit(ev: FormEvent) {
    ev.preventDefault();
    setError(null);
    setEnviando(true);
    try {
      const usuario = await login(email, password);
      const from = (location.state as { from?: string } | null)?.from;
      navigate(from ?? rutaInicioPorRol(usuario.rol), { replace: true });
    } catch (e) {
      setError(mensajeDeError(e));
    } finally {
      setEnviando(false);
    }
  }

  return (
    <AdultScreen>
      <Content>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 12 }}>
          <Mascot size={64} float={false} />
          <div>
            <h1 style={{ fontSize: 24 }}>{t("app.name")}</h1>
            <p style={{ color: "var(--ink-soft)", fontSize: 13 }}>{t("app.tagline")}</p>
          </div>
        </div>
        <Card>
          <h2>{t("auth.login.title")}</h2>
          <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: 14, marginTop: 12 }}>
            {error ? <ErrorBanner message={error} /> : null}
            <Field label={t("auth.login.email")}>
              <TextInput
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Field>
            <Field label={t("auth.login.password")}>
              <TextInput
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Field>
            <Button type="submit" block disabled={enviando}>
              {enviando ? t("common.loading") : t("auth.login.submit")}
            </Button>
          </form>
        </Card>
        <Link to="/register" style={{ textAlign: "center", fontWeight: 700 }}>
          {t("auth.login.toRegister")}
        </Link>
        <Link to="/terapeutas" style={{ textAlign: "center", fontSize: 13, color: "var(--ink-soft)" }}>
          {t("marketplace.title")} →
        </Link>
        <AppVersion />
      </Content>
    </AdultScreen>
  );
}
